module.exports = __webpack_public_path__ + "img/list_7_zh.1e1344ac.png";